import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { getSettingAdyenEligibleCountries } from "@faire/help-center-utils/settings/getSettingAdyenEligibleCountries";
import React from "react";
import { GoToPayoutSettingsCTA } from "./ctas";
import { CANPayoutsIA } from "./instantAnswersComponents/payments/CANPayoutsIA";
import { EligibleAdyenCountriesPayoutsIA } from "./instantAnswersComponents/payments/EligibleAdyenCountriesPayoutsIA";
import { USPayoutsIA } from "./instantAnswersComponents/payments/USPayoutsIA";
export var setUpPayouts = function setUpPayouts(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return SETTING_UP_PAYOUTS_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return SETTING_UP_PAYOUTS_DESCRIPTION(context);
    }
  };
};
var SETTING_UP_PAYOUTS_TITLE = function SETTING_UP_PAYOUTS_TITLE(strictLocalize) {
  return strictLocalize({
    id: "qmMrkV",
    defaultMessage: [{
      "type": 0,
      "value": "Setting up payouts"
    }]
  });
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return GoToPayoutSettingsCTA(strictLocalize);
};
var SETTING_UP_PAYOUTS_DESCRIPTION = function SETTING_UP_PAYOUTS_DESCRIPTION(context) {
  var brand = context.brand;
  if (!brand || !brand.based_in) {
    return [];
  }
  if (getSettingAdyenEligibleCountries().includes(brand.based_in)) {
    return /*#__PURE__*/React.createElement(EligibleAdyenCountriesPayoutsIA, null);
  } else if ((brand === null || brand === void 0 ? void 0 : brand.based_in) === "CAN") {
    return /*#__PURE__*/React.createElement(CANPayoutsIA, null);
  } else {
    return /*#__PURE__*/React.createElement(USPayoutsIA, null);
  }
};